import { get } from '@eika-infrastruktur/request';
import { getApiUrl } from '../utils';

export interface NextStepResponse {
    nextStep: string;
}

export const getNextStep = async (processId: string) => {
    const response = await get<NextStepResponse>(getApiUrl(`process/${processId}/next-step`));

    return response.nextStep;
};
